import { useConfirmationStore } from '@/platform/stores/useConfirmationStore';
import { Button, Segment, SegmentContent, SegmentHeader } from '@/platform/ui';
import { PlusIcon } from '@heroicons/react/24/outline';
import { router, usePage } from '@inertiajs/react';
import QuestionnaireCard from './components/QuestionnaireCard';
import EmployeeShowLayout from './layouts/EmployeeShowLayout';

const QuestionnaireView = () => {
    const { employee } = usePage().props;
    const { confirm, setLoading } = useConfirmationStore();

    const handleNewQuestionnaire = () =>
        confirm({
            title: 'Nieuwe vragenlijst aanmaken?',
            description:
                'Er wordt een nieuwe vragenlijst voor deze werknemer opgebouwd op basis van de laatste DGR-controle. Dit gebeurt op de achtergrond.',
            confirmLabel: 'Aanmaken',
            variant: 'primary',
            icon: <PlusIcon />,
            onConfirm: close => {
                setLoading(true);

                router.post(
                    `/customers/${employee.customer_id}/employees/${employee.id}/questionnaires`,
                    {},
                    {
                        reset: ['employee', 'navigation'],
                        preserveState: true,
                        preserveScroll: true,
                        onFinish: close,
                    }
                );
            },
        });

    return (
        <>
            <div className='my-4 flex items-center justify-end'>
                <Button variant='primary' onClick={handleNewQuestionnaire}>
                    <PlusIcon className='size-4' />
                    Nieuwe vragenlijst aanmaken
                </Button>
            </div>

            {employee?.questionnaires?.length === 0 ? (
                <Segment>
                    <SegmentHeader header='Vragenlijsten'></SegmentHeader>
                    <SegmentContent>
                        <p className='text-sm text-gray-500'>
                            Deze werknemer heeft nog geen vragenlijsten.
                        </p>
                    </SegmentContent>
                </Segment>
            ) : (
                employee?.questionnaires?.map(questionnaire => (
                    <QuestionnaireCard
                        key={questionnaire.id}
                        questionnaire={questionnaire}
                    />
                ))
            )}
        </>
    );
};

QuestionnaireView.layout = page => (
    <EmployeeShowLayout>{page}</EmployeeShowLayout>
);

export default QuestionnaireView;
